/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCalendarWeek} from '@fortawesome/pro-duotone-svg-icons';

const SchedulingIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faCalendarWeek} {...props} />
);

export default SchedulingIcon;
